import React, { useContext } from 'react';

import {
  ControllerContainer,
  ControllerSettingsContainer,
} from './DeletePageConfirmation.styled';

import CloseIcon from '../../../assets/icons/close.svg';

import { FileContext } from '../../../context/FileContext';
import { useNavigate } from 'react-router-dom';

const CkEditorConfirmationModal = ({
  type,
  redirectionUrl,
  fromTemplateGallery = false,
  templateId = null,
}) => {
  const navigate = useNavigate();

  const { setShowCKEditorEntryConfirmation, fileId, itemId, envelopeId } =
    useContext(FileContext);

  function redirectToCkEditor() {
    const path = redirectionUrl
      ? redirectionUrl
      : type === 'generate'
      ? `/${fileId}/${itemId}/word-editor`
      : `/${
          fromTemplateGallery ? templateId : envelopeId
        }/${fileId}/${itemId}/word-editor?fromTemplateGallery=${fromTemplateGallery}${
          type === 'adhoc' ? '&isAdhoc=true' : ''
        }`;

    setShowCKEditorEntryConfirmation(false);
    navigate(path);
  }

  const handleClose = () => {
    setShowCKEditorEntryConfirmation(false);
  };

  return (
    <ControllerContainer>
      <ControllerSettingsContainer>
        <div className="header">
          Leave this page?
          <img
            className="icon"
            src={CloseIcon}
            alt="close"
            onClick={handleClose}
          />
        </div>

        <div className="content">
          <div>Changes you made may not be saved.</div>
        </div>
        <div className="footer">
          <button className="info" onClick={redirectToCkEditor}>
            Leave
          </button>
          <button className="outlined" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </ControllerSettingsContainer>
    </ControllerContainer>
  );
};

export default CkEditorConfirmationModal;
